/*
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2021-09-10 17:34:29
 * @LastEditTime: 2021-10-11 15:07:19
 * @Description: file content
 */
import Cookies from "js-cookie";

const TokenKey = "scim_common_token";
// const ACCESS_TOKEN = "access_token";
const REFRESH_TOKEN = "refresh_token";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function clearAllCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if(keys) {
      for(var i = keys.length; i--;)
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
  }
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getRefreshToken() {
  return Cookies.get(REFRESH_TOKEN);
}

export function setRefreshToken(token) {
  return Cookies.set(REFRESH_TOKEN, token);
}

export function removeRefreshToken() {
  return Cookies.remove(REFRESH_TOKEN);
}

export function setLang(lang) {
  lang = lang || "zh";
  const hostname = location.hostname.split(".");
  if (hostname[hostname.length - 1] === "com") {
    return Cookies.set("lang", lang, {
      domain: `.${hostname[hostname.length - 2]}.${hostname[hostname.length - 1]}`
    });
  } else {
    return Cookies.set("lang", lang);
  }
}

export function getLang(lang) {
  const languagne = Cookies.get("lang") || "zh";
  return languagne;
}
